import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import * as FileSaver from 'file-saver';

import { EntityService, SharedService } from '@app/core';
import { DashboardService } from '@modules/dashboard/services';

@Component({
  selector: 'app-supplier',
  templateUrl: './supplier.component.html',
  styleUrls: ['./supplier.component.scss']
})
export class SupplierComponent implements OnInit, OnChanges, OnDestroy {
  @Input() isTabActive: boolean;
  @Input() duration: { startDate: string, endDate: string, dateField: string };
  previousDuration: { startDate: string, endDate: string, dateField: string };
  supplierCount: { suppliers: number, change: number };
  reviewedInvoiceCount: { count: number, change: number };
  invoiceAmount: { amount: number, change: number };
  invoiceGst: { gst: number, change: number };
  isSupplierLoading: boolean = true;
  isReviewedInvoiceLoading: boolean = true;
  isInvoiceAmountLoading: boolean = true;
  isInvoiceGstLoading: boolean = true;
  isSupplierWiseSummaryLoading: boolean = true;
  treemapSeries: {
    x: string,
    y: number,
    meta: {
      count: number,
      percentage: number;
    }
  }[];
  mixedSeries: { name: string, type: string, data: any[], tax?: { gsts: number[], vats: number[], cesses: number[], excises: number[] } }[];
  mixedCategories: string[];
  mixedYAxisRange: { min: number, max: number }[];
  supplierFilterForm: FormGroup;
  supplierList: any[] = [];
  filteredSupplierList: any[] = [];
  isSupplierListLoading: boolean = true;
  sortBy: string = 'name';
  sortOrder: ('ASC' | 'DESC') = 'ASC';
  private destroy$: Subject<void> = new Subject<void>();
  downloadReport: boolean = false;

  constructor(private dashboardService: DashboardService,
    public sharedService: SharedService,
    private formBuilder: FormBuilder,
    private entityService: EntityService) { }


  ngOnInit(): void {
    this.createSupplierFilterForm();
    this.entityService.entitiesChanges$.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (this.isTabActive && this.duration?.startDate && this.duration?.endDate || res.isEntityChanged) {
        this.getSupplierCount();
      }
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.isTabActive && this.duration?.startDate && this.duration?.endDate &&
      (this.duration?.startDate !== this.previousDuration?.startDate || this.duration?.endDate !== this.previousDuration?.endDate || this.duration?.dateField !== this.previousDuration?.dateField)) {
      this.getSupplierCount();
    }
  }

  getSupplierCount() {
    this.previousDuration = this.duration;
    this.isSupplierLoading = true;
    this.isReviewedInvoiceLoading = true;
    this.isInvoiceAmountLoading = true;
    this.isInvoiceGstLoading = true;
    this.isSupplierWiseSummaryLoading = true;
    this.isSupplierListLoading = true;
    this.getSupplierTabDashboard();
  }

  get f() { return this.supplierFilterForm.controls; };

  createSupplierFilterForm() {
    this.supplierFilterForm = this.formBuilder.group({
      searchTerm: ['']
    });

    this.f.searchTerm.valueChanges.subscribe(searchTerm => {
      this.filteredSupplierList = searchTerm ?
        this.supplierList.filter(supplier => supplier.name.toLowerCase().includes(searchTerm.toLowerCase())) :
        this.supplierList;
    });
  }

  clearSupplierFilter() {
    this.supplierFilterForm.reset();
  }

  getSupplierTabDashboard() {
    this.dashboardService.getSupplierTabDashboard(this.duration).subscribe((res) => {
      this.isSupplierLoading = false;
      this.isReviewedInvoiceLoading = false;
      this.isInvoiceAmountLoading = false;
      this.isInvoiceGstLoading = false;

      this.supplierCount = res.supplierCount;
      this.reviewedInvoiceCount = res.reviewedInvoiceCount;
      this.invoiceAmount = res.invoiceAmount;
      this.invoiceGst = res.invoiceGst;
      this.getSupplierWiseInvoiceSummary(res.supplierWiseInvoiceSummary);
    }, (error: any) => {
      this.sharedService.errorAlert(error);
      this.isSupplierLoading = false;
    });
  }


  // getCount() {
  //   this.isSupplierLoading = true;
  //   this.dashboardService.getSupplierCount(this.duration).subscribe((res) => {
  //     this.getReviewedInvoiceCount();
  //     this.supplierCount = res;
  //     this.isSupplierLoading = false;
  //   }, (error: any) => {
  //     this.sharedService.errorAlert(error);
  //     this.isSupplierLoading = false;
  //   });
  // }

  // getReviewedInvoiceCount() {
  //   this.isReviewedInvoiceLoading = true;
  //   this.dashboardService.getReviewedInvoiceCount(this.duration).subscribe(
  //     (res) => {
  //       this.reviewedInvoiceCount = res;
  //       this.getInvoiceAmount();
  //       this.isReviewedInvoiceLoading = false;
  //     },
  //     (error: any) => {
  //       this.sharedService.errorAlert(error);
  //       this.isReviewedInvoiceLoading = false;
  //     }
  //   );
  // }

  // getInvoiceAmount() {
  //   this.isInvoiceAmountLoading = true;
  //   this.dashboardService.getInvoiceAmount(this.duration).subscribe(
  //     (res) => {
  //       this.invoiceAmount = res;
  //       this.isInvoiceAmountLoading = false;
  //       this.getInvoiceGST();
  //     },
  //     (error: any) => {
  //       this.sharedService.errorAlert(error);
  //       this.isInvoiceAmountLoading = false;
  //     }
  //   );
  // }

  // getInvoiceGST() {
  //   this.isInvoiceGstLoading = true;
  //   this.dashboardService.getInvoieGst(this.duration).subscribe(
  //     (res) => {
  //       this.invoiceGst = res;
  //       this.isInvoiceGstLoading = false;
  //       this.getSupplierWiseInvoiceSummary();
  //     },
  //     (error: any) => {
  //       this.sharedService.errorAlert(error);
  //       this.isInvoiceGstLoading = false;
  //     }
  //   );
  // }

  getSupplierWiseInvoiceSummary(res) {
    this.isSupplierWiseSummaryLoading = true;
    // this.dashboardService.getSupplierWiseInvoiceSummary(this.duration).subscribe((res) => {
    this.isSupplierWiseSummaryLoading = false;
    const sum = res.reduce((sum, stat) => sum + stat.amount, 0);
    const modifiedSuppliers = res.reduce((final, stat) => {
      if (!sum || stat.amount / sum > 0.01) {
        final.suppliers.push(stat);
      } else {
        final.otherSuppliers.push(stat);
      }

      return final;
    }, { suppliers: [], otherSuppliers: [] });
    this.treemapSeries = [
      ...modifiedSuppliers.suppliers.map(supplier => ({
        ...supplier,
        supplier: supplier.supplier
      })),
      ...(modifiedSuppliers.otherSuppliers?.length ? [modifiedSuppliers.otherSuppliers.reduce((final, stat) => ({
        supplier: 'Other',
        count: final.count + stat.count,
        amount: final.amount + stat.amount,
        gst: final.gst + stat.gst,
        vat: final.vat + stat.vat,
        cess: final.cess + stat.cess,
        excise: final.excise + stat.excise
      }), { count: 0, amount: 0, gst: 0, vat: 0, cess: 0, excise: 0 })] : [])
    ].map(stat => ({
      x: stat.supplier,
      y: stat.amount,
      z: stat.gst + stat.vat + stat.cess + stat.excise,
      meta: {
        count: stat.count,
        gst: stat.gst,
        vat: stat.vat,
        cess: stat.cess,
        excise: stat.excise,
        percentage: 0
      },
    }));
    // Calculate the sum of values for the series
    const totalSum = this.treemapSeries.reduce((a: any, b: any) => a + b.y, 0);
    this.treemapSeries.forEach((seriesObject) => {
      const value = seriesObject.y;
      seriesObject.meta.percentage = +(totalSum ? (value / totalSum) * 100 : 0).toFixed(0);
    })


    this.mixedCategories = res.map(supplier => supplier.supplier);
    const supplierAmount = res.map((supplier) => supplier.amount);
    const supplierTaxes = res.map((supplier) => supplier.gst + supplier.vat + supplier.cess + supplier.excise);
    const gsts = res.map(stat => stat.gst);
    const vats = res.map(stat => stat.vat);
    const cesses = res.map(stat => stat.cess);
    const excises = res.map(stat => stat.excise);
    const supplierReviewedCount = res.map((supplier) => supplier.count);
    this.mixedSeries = [
      {
        name: "Payable Amount",
        type: "bar",
        data: supplierAmount
      },
      {
        name: "Total Taxes",
        type: "bar",
        data: supplierTaxes,
        tax: { gsts, vats, cesses, excises }
      },
      {
        name: "No. of Invoices Reviewed",
        type: "line",
        data: supplierReviewedCount
      }
    ];
    this.mixedYAxisRange = [
      {
        min: Math.min(...supplierAmount, ...supplierTaxes),
        max: Math.max(...supplierAmount, ...supplierTaxes)
      },
      {
        min: Math.min(...supplierAmount, ...supplierTaxes),
        max: Math.max(...supplierAmount, ...supplierTaxes)
      }
    ];
    this.getSuppliers();
    this.isSupplierWiseSummaryLoading = false;
    // },
    //   (error: any) => this.sharedService.errorAlert(error)
    // );
  }

  treemapCustomTooltip = ({ series, seriesIndex, dataPointIndex, w }) => {
    const data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];
    const color = w.config.colors[dataPointIndex];

    // Calculate the sum of values for the series
    const sum = series[seriesIndex].reduce((a, b) => a + b, 0);

    // Calculate the percentage for the current data point
    const value = series[seriesIndex][dataPointIndex];
    const percent = sum ? (value / sum) * 100 : 0;

    return '<div class="arrow_box"><div class="apexcharts-tooltip-title apxcharts-active">' + this.sharedService.capitalize(data.x) + '</div>' +
      '<div class="apexcharts-tooltip-series-group" style="order: 1; display: flex;">' +
      '<span class="apexcharts-tooltip-marker" style="background-color: rgb(253, 127, 111); display: block;"></span>' +
      '<div class="apexcharts-tooltip-text" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; display: block;">' +
      '<div class="apexcharts-tooltip-y-group"><span class="apexcharts-tooltip-text-y-label">Payable Amount: </span>' +
      '<span class="apexcharts-tooltip-text-y-value">' + this.sharedService.formatNumber(value, true, 0, 2, true) + ' (' + percent.toFixed(0) + '%)' + '</span></div>' +
      '<div class="apexcharts-tooltip-goals-group"><span class="apexcharts-tooltip-text-goals-label"></span>' +
      '<span class="apexcharts-tooltip-text-goals-value"></span></div>' +
      '<div class="apexcharts-tooltip-z-group"><span class="apexcharts-tooltip-text-z-label"></span>' +
      '<span class="apexcharts-tooltip-text-z-value"></span></div></div></div>' +
      '<div class="apexcharts-tooltip-series-group khr-taxes-group" style="order: 2; display: flex;">' +
      '<span class="apexcharts-tooltip-marker" style="background-color: #ebb901; display: block;"></span>' +
      '<div class="apexcharts-tooltip-text" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; display: block;">' +
      '<div class="apexcharts-tooltip-y-group pb-0">' +
      '<span class="apexcharts-tooltip-text-y-label">Total Taxes: </span>' +
      '<span class="apexcharts-tooltip-text-y-value">' + this.sharedService.formatNumber(data.z, true, 0, 2, true) + '</span>' +
      '</div>' +
      '<div class="d-flex khr-taxes-list">' +
      '<div>' +
      '<p class="apexcharts-tooltip-text-y-label mb-0">GST</p>' +
      '<p class="apexcharts-tooltip-text-y-value mb-0">' + this.sharedService.formatNumber(data.meta?.gst, true, 0, 2, true) + '</p>' +
      '</div>' +
      '<div>' +
      '<p class="apexcharts-tooltip-text-y-label mb-0">VAT</p>' +
      '<p class="apexcharts-tooltip-text-y-value mb-0">' + this.sharedService.formatNumber(data.meta?.vat, true, 0, 2, true) + '</p>' +
      '</div>' +
      '<div>' +
      '<p class="apexcharts-tooltip-text-y-label mb-0">CESS</p>' +
      '<p class="apexcharts-tooltip-text-y-value mb-0">' + this.sharedService.formatNumber(data.meta?.cess, true, 0, 2, true) + '</p>' +
      '</div>' +
      '<div>' +
      '<p class="apexcharts-tooltip-text-y-label mb-0">Excise</p>' +
      '<p class="apexcharts-tooltip-text-y-value mb-0">' + this.sharedService.formatNumber(data.meta?.excise, true, 0, 2, true) + '</p>' +
      '</div>' +
      '</div>' +
      '<div class="apexcharts-tooltip-goals-group">' +
      '<span class="apexcharts-tooltip-text-goals-label"></span>' +
      '<span class="apexcharts-tooltip-text-goals-value"></span>' +
      '</div>' +
      '<div class="apexcharts-tooltip-z-group">' +
      '<span class="apexcharts-tooltip-text-z-label"></span>' +
      '<span class="apexcharts-tooltip-text-z-value"></span>' +
      '</div>' +
      '</div>' +
      '</div>';
  }

  mixedCustomTooltip = ({ series, seriesIndex, dataPointIndex, w }) => {
    const { seriesNames, categoryLabels, initialSeries } = w.globals;

    return '<div class="arrow_box">' + '<div class="apexcharts-tooltip-title apxcharts-active">' + categoryLabels[dataPointIndex] + '</div>' +
      '<div class="apexcharts-tooltip-series-group" style="order: 1; display: flex;">' +
      '<span class="apexcharts-tooltip-marker" style="background-color: rgb(253, 127, 111); display: block;"></span>' +
      '<div class="apexcharts-tooltip-text" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; display: block;">' +
      '<div class="apexcharts-tooltip-y-group"><span class="apexcharts-tooltip-text-y-label">' + seriesNames[0] + ': </span>' +
      '<span class="apexcharts-tooltip-text-y-value">' + this.sharedService.formatNumber(series[0][dataPointIndex], true, 0, 2, true) + '</span></div>' +
      '<div class="apexcharts-tooltip-goals-group"><span class="apexcharts-tooltip-text-goals-label"></span>' +
      '<span class="apexcharts-tooltip-text-goals-value"></span></div>' +
      '<div class="apexcharts-tooltip-z-group"><span class="apexcharts-tooltip-text-z-label"></span>' +
      '<span class="apexcharts-tooltip-text-z-value"></span></div></div></div>' +
      '<div class="apexcharts-tooltip-series-group khr-taxes-group" style="order: 2; display: flex;">' +
      '<span class="apexcharts-tooltip-marker" style="background-color: #ebb901; display: block;"></span>' +
      '<div class="apexcharts-tooltip-text" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; display: block;">' +
      '<div class="apexcharts-tooltip-y-group pb-0">' +
      '<span class="apexcharts-tooltip-text-y-label">' + seriesNames[1] + ': </span>' +
      '<span class="apexcharts-tooltip-text-y-value">' + this.sharedService.formatNumber(series[1][dataPointIndex], true, 0, 2, true) + '</span>' +
      '</div>' +
      '<div class="d-flex khr-taxes-list">' +
      '<div>' +
      '<p class="apexcharts-tooltip-text-y-label mb-0">GST</p>' +
      '<p class="apexcharts-tooltip-text-y-value mb-0">' + this.sharedService.formatNumber(initialSeries[1].tax.gsts[dataPointIndex], true, 0, 2, true) + '</p>' +
      '</div>' +
      '<div>' +
      '<p class="apexcharts-tooltip-text-y-label mb-0">VAT</p>' +
      '<p class="apexcharts-tooltip-text-y-value mb-0">' + this.sharedService.formatNumber(initialSeries[1].tax.vats[dataPointIndex], true, 0, 2, true) + '</p>' +
      '</div>' +
      '<div>' +
      '<p class="apexcharts-tooltip-text-y-label mb-0">CESS</p>' +
      '<p class="apexcharts-tooltip-text-y-value mb-0">' + this.sharedService.formatNumber(initialSeries[1].tax.cesses[dataPointIndex], true, 0, 2, true) + '</p>' +
      '</div>' +
      '<div>' +
      '<p class="apexcharts-tooltip-text-y-label mb-0">Excise</p>' +
      '<p class="apexcharts-tooltip-text-y-value mb-0">' + this.sharedService.formatNumber(initialSeries[1].tax.excises[dataPointIndex], true, 0, 2, true) + '</p>' +
      '</div>' +
      '</div>' +
      '<div class="apexcharts-tooltip-goals-group">' +
      '<span class="apexcharts-tooltip-text-goals-label"></span>' +
      '<span class="apexcharts-tooltip-text-goals-value"></span>' +
      '</div>' +
      '<div class="apexcharts-tooltip-z-group">' +
      '<span class="apexcharts-tooltip-text-z-label"></span>' +
      '<span class="apexcharts-tooltip-text-z-value"></span>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '<div class="apexcharts-tooltip-series-group" style="order: 3; display: flex;">' +
      '<span class="apexcharts-tooltip-marker" style="background-color: rgb(126, 176, 213); display: block;"></span>' +
      '<div class="apexcharts-tooltip-text" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; display: block;">' +
      '<div class="apexcharts-tooltip-y-group"><span class="apexcharts-tooltip-text-y-label">' + seriesNames[2] + ': </span>' +
      '<span class="apexcharts-tooltip-text-y-value">' + this.sharedService.formatNumber(series[2][dataPointIndex], false, 0, 2, true) + '</span></div>' +
      '<div class="apexcharts-tooltip-goals-group"><span class="apexcharts-tooltip-text-goals-label"></span>' +
      '<span class="apexcharts-tooltip-text-goals-value"></span></div>' +
      '<div class="apexcharts-tooltip-z-group"><span class="apexcharts-tooltip-text-z-label"></span>' +
      '<span class="apexcharts-tooltip-text-z-value"></span></div></div></div></div>';
  }

  getSuppliers() {
    this.isSupplierListLoading = true;
    this.dashboardService.getSuppliers(this.duration).subscribe(
      (res) => {
        this.supplierList = res;
        this.filteredSupplierList = res.filter(supplier => supplier.name.toLowerCase().includes(this.f.searchTerm.value.toLowerCase()));
        this.isSupplierListLoading = false;
      },
      (error: any) => {
        this.sharedService.errorAlert(error);
        this.isSupplierListLoading = false;
      }
    );
  }

  sortSuppliers(column) {
    const isSameColumn = this.sortBy && this.sortBy === column;
    const isInitialSortType = this.sortOrder === 'DESC';

    this.sortBy = !isSameColumn || isInitialSortType ? column : 'name';
    this.sortOrder = isSameColumn && isInitialSortType ? 'ASC' : 'DESC';

    const sortOrder = this.sortOrder === 'ASC' ? 1 : -1;
    this.filteredSupplierList = this.filteredSupplierList.sort((a, b) => (a?.[column] > b?.[column] ? sortOrder : a?.[column] < b?.[column] ? sortOrder * -1 : 0));
  }

  downloadSupplierInvoiceSummaryReport() {
    this.downloadReport = true;
    this.dashboardService.getSupplierInvoiceSummaryReport(this.duration).subscribe(result => {
      this.exportSupplierInvoiceSummaryToCsv(result);
      this.downloadReport = false;
    }, error => {
      console.error(error.message);
      this.sharedService.errorAlert('Error while downloading report');
      this.downloadReport = false;
    })
  }

  exportSupplierInvoiceSummaryToCsv(dataToExport) {
    if (dataToExport.length) {
      const separator = ',';
      const columns = [
        'Invoice No',
        'Invoice Date',
        'Supplier',
        'Supplier GST',
        'Amount',
        'CGST',
        'SGST',
        'IGST',
        'Cess',
        'Vat',
        'Excise',
        'TDS',
        'TCS'
      ];
      const keys = [
        'invoiceNo',
        'invoiceDate',
        'supplierName',
        'suppliergst',
        'amount',
        'cgst',
        'sgst',
        'igst',
        'cess',
        'vat',
        'excise',
        'tds',
        'tcs'
      ]

      const rowsContent = dataToExport.map(row => {
        return keys.map(k => {
          let cell = row[k] ?? '';
          cell = cell instanceof Date
            ? cell.toLocaleString()
            : cell.toString().replace(/"/g, '""');
          if (cell.search(/("|,|\n)/g) >= 0) {
            cell = `"${cell}"`;
          }
          return cell;
        }).join(separator)
      }).join('\n');

      const csvContent = columns.join(separator) + '\n' + rowsContent;

      const data = new Blob([csvContent], { type: 'text/plain;charset=utf-8' });

      FileSaver.saveAs(data, `Supplier List Report ${new Date(this.duration['startDate']).toLocaleDateString('en-CA')}-${new Date(this.duration['endDate']).toLocaleDateString('en-CA')}.csv`);
    };
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}